import { RouteLocationNormalizedGeneric, RouteLocationNormalizedLoaded } from 'vue-router'
import { mapRouterList } from '@/router/map'
import { isMobile } from '@/utils/Device'
import { getPcUrl } from '@/utils/urlMapping'
import { isTouristChannel } from '@/hooks/useSurveyChannel'

type MapRoute = { name: string; key: string | null; pcName: string }

const jumpPlatform = (route: RouteLocationNormalizedLoaded) => {
  if (isMobile()) {
    return
  }

  setTimeout(() => {
    const pcUrl = getPcUrl()
    const routerName = route.name as string

    const mapRoute = mapRouterList.find((item) => item.name === routerName)

    if (routerName && mapRoute) {
      if (!mapRoute.key) {
        window.location.href = `${pcUrl}${mapRoute.pcName}`
      } else if (mapRoute.key && mapRoute.name === 'live') {
        const fullHash = window?.location?.href
        var idMatch = fullHash.match(/id=(\d+)/)
        var typeMatch = fullHash.match(/type=(\d+)/)
        // 提取id参数的值，如果不存在则为null
        var id = idMatch ? idMatch[1] : null
        // 提取type参数的值，如果不存在则默认为0
        var type = typeMatch ? typeMatch[1] : 0
        window.location.href = `${pcUrl}live/auth?id=${id}&type=${type}`
      } else if (mapRoute.key && mapRoute.key === 'query.redirect' && mapRoute.name === 'login') {
        // 解码URL
        if (window?.location?.hash?.includes('live')) {
          const decodedURL = decodeURIComponent(`${route.query.redirect}`)
          window.location.href = `${pcUrl}live/auth?${decodedURL.split('?')[1]}`
        } else {
          // alert('H5没有登录')
          const decodedURL = decodeURIComponent(`${route.query.redirect}`)
          if (decodedURL && decodedURL !== '/') {
            if (window?.location?.hash?.includes('rollVideo')) {
              // const params = `id=${route.query.id}&boardId=${route.query.boardId}&boardType=2`
              const decodedURL = decodeURIComponent(`${route.query.redirect}`)
              window.location.href = `${pcUrl}community/communityDetail?${decodedURL.split('?')[1]}`
            } else if (window?.location?.hash?.includes('communityDetail')) {
              const decodedURL = decodeURIComponent(`${route.query.redirect}`)
              window.location.href = `${pcUrl}community/communityPlate?${decodedURL.split('?')[1]}`
            } else if (window?.location?.hash?.includes('examInfo')) {
              // alert("考试")
              const decodedURL = decodeURIComponent(`${route.query.redirect}`)
              window.location.href = `${pcUrl}exam/examEntrance?${decodedURL.split('?')[1]}`
            } else if (window?.location?.hash?.includes('trainingDetail')) {
              // alert("培训")
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/id=(\d+)/)
              var id = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}train/trainPage?taskId=${id}`
            } else if (window?.location?.hash?.includes('SelfRegistrationDetail')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/id=(\d+)/)
              var id = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}signAuto?id=${id}`
            } else if (window?.location?.hash?.includes('lecturerDetail')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/lecturerId=(\d+)/)
              var lecturerId = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}lecturerDetail?lecturerId=${lecturerId}`
            } else if (window?.location?.hash?.includes('faceDetail')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/faceId=(\d+)/)
              var faceId = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}faceDetail?faceId=${faceId}`
            } else if (window?.location?.hash?.includes('ExamPractiseInfo')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/practiseId=(\d+)/)
              var practiseId = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}practice?practiceId=${practiseId}`
            } else if (window?.location?.hash?.includes('broadcastDetail')) {
              // alert("行业动态")
              var url = window.location.href
              var decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var regex = /\/broadcastDetail\/(\d+)/
              var match = decodedUrl.match(regex)
              var id: string | null
              if (match) {
                id = match[1]
              } else {
                id = null
              }
              window.location.href = `${pcUrl}trendsDetail?id=${id}`
            } else if (window?.location?.hash?.includes('broadcast')) {
              window.location.href = `${pcUrl}fieldTrends?ids=&dataShowRule=1`
            } else if (window?.location?.hash?.includes('applyDetail')) {
              // alert("报名中心")
              const decodedURL = decodeURIComponent(`${route.query.redirect}`)
              window.location.href = `${pcUrl}signDetail?${decodedURL.split('?')[1]}`
            } else if (window?.location?.hash?.includes('task')) {
              // alert("任务")
              window.location.href = `${pcUrl}studyTask`
            } else if (window?.location?.hash?.includes('comDetailLevel')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var idMatch = decodedUrl.match(/id=(\d+)/)
              var id = idMatch ? idMatch[1] : null
              window.location.href = `${pcUrl}community/communityDetail?boardType=1&id=${id}`
            } else if (window?.location?.hash?.includes('community')) {
              window.location.href = `${pcUrl}community/communityHome`
            } else if (window?.location?.hash?.includes('courseDetail')) {
              const url = window?.location?.href
              const decodedUrl = decodeURIComponent(decodeURIComponent(url))
              var courseTypeMatch = decodedUrl.match(/courseType=([^&]+)/)
              var idMatch = decodedUrl.match(/id=(\d+)/)
              var id = idMatch ? idMatch[1] : null
              var courseType = courseTypeMatch ? courseTypeMatch[1] : null
              if (courseType === 'courseWare') {
                debugger
                window.location.href = `${pcUrl}resource/courseDetails?id=${id}&fileType=1&channel=0`
                debugger
              } else {
                debugger
                window.location.href = `${pcUrl}resource/courseDetails?id=${id}&fileType=0&channel=0`
                debugger
              }
            } else if (window?.location?.hash?.includes('applyCenter')) {
              window.location.href = `${pcUrl}sign`
            } else if (window?.location?.hash?.includes('course')) {
              window.location.href = `${pcUrl}resource/dailyLesson`
            } else if (window?.location?.hash?.includes('surveyDetails')) {
              const id = `${route.query.investigationId}`
              if (isTouristChannel(route.query.channel as string)) {
                const params = buildTouristSurveyParams(route.query)
                window.location.href = `${pcUrl}survey/surveyPage?surveyId=${id}${params}`
              } else {
                window.location.href = `${pcUrl}survey/surveyPage?surveyId=${id}&type=1`
              }
            } else if (window?.location?.hash?.includes('surveyInfo')) {
              const id = `${route.query.investigationId}`
              window.location.href = `${pcUrl}survey/surveyEntrance?surveyId=${id}`
            } else {
              if (window?.location?.hash?.includes('login')) {
                window.location.href = `${pcUrl}`
              } else {
                const decodedURL = decodeURIComponent(`${route.query.redirect}`)
                window.location.href = `${pcUrl}${decodedURL.split('?')[1]}`
              }
            }
          } else {
            window.location.href = `${pcUrl}`
          }
        }
      } else if (mapRoute.key && mapRoute.key === 'many') {
        // alert("登录过账号的")
        if (route.name === 'courseDetail') {
          const params = `id=${route.query.courseId || route.query.id}&fileType=${
            route.query.courseType !== 'course' && !route.query.courseId ? 1 : 0
          }&channel=${route.query.channel}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'rollVideo') {
          // alert('短视频4')
          const params = `id=${route.query.id}&boardId=${route.query.boardId}&boardType=2`
          window.location.href = `${pcUrl}${mapRoute.pcName}?${params}`
        } else if (route.name === 'communityDetail') {
          const params = `id=${route.query.id}`
          window.location.href = `${pcUrl}${mapRoute.pcName}?${params}`
        } else if (route.name === 'ExamInfo') {
          // alert('考试')
          const params = `${route.query.examId}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'surveyInfo') {
          const id = `${route.query.investigationId}`
          window.location.href = `${pcUrl}survey/surveyEntrance?surveyId=${id}`
        } else if (route.name === 'surveyDetails') {
          const id = `${route.query.investigationId}`
          if (isTouristChannel(route.query.channel as string)) {
            const params = buildTouristSurveyParams(route.query)
            window.location.href = `${pcUrl}survey/surveyPage?surveyId=${id}${params}`
          } else {
            window.location.href = `${pcUrl}survey/surveyView?surveyId=${id}&type=1`
          }
        } else if (route.name === 'trainingDetail') {
          // alert("培训")
          const params = `${route.query.id}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'SelfRegistrationDetail') {
          const params = `${route.query.id}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'ExamPractiseInfo') {
          const params = `${route.query.practiseId}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'broadcastDetail') {
          var url = window.location.href
          var regex = /\/broadcastDetail\/(\d+)/
          var match = url.match(regex)
          var id: string | null
          if (match) {
            id = match[1]
          } else {
            id = null
          }
          window.location.href = `${pcUrl}${mapRoute.pcName}${id}`
        } else if (route.name === 'applyDetail') {
          // alert("报名中心")
          const params = `${route.query.id}`
          window.location.href = `${pcUrl}${mapRoute.pcName}${params}`
        } else if (route.name === 'comDetailLevel') {
          const fullHash = window?.location?.href
          const parts = fullHash.split('?')
          const queryString = parts[1]
          const queryParams = new URLSearchParams(queryString)
          const id = queryParams.get('id')
          window.location.href = `${pcUrl}${mapRoute.pcName}${id}`
        } else if (route.name === 'broadcast') {
          window.location.href = `${pcUrl}${mapRoute.pcName}`
        } else if (route.name === 'lecturerDetail') {
          const fullHash = window?.location?.href
          var idMatch = fullHash.match(/lecturerId=(\d+)/)
          var lecturerId = idMatch ? idMatch[1] : null
          window.location.href = `${pcUrl}lecturerDetail?lecturerId=${lecturerId}`
        } else if (route.name === 'faceDetail') {
          const fullHash = window?.location?.href
          var idMatch = fullHash.match(/faceId=(\d+)/)
          var faceId = idMatch ? idMatch[1] : null
          window.location.href = `${pcUrl}faceDetail?faceId=${faceId}`
        } else if (route.name === 'signDetail') {
          const fullHash = window?.location?.href
          var idMatch = fullHash.match(/trainConfirmId=(\d+)/)
          var trainConfirmId = idMatch ? idMatch[1] : null
          window.location.href = `${pcUrl}${mapRoute.pcName}${trainConfirmId}`
        }
      } else if (mapRoute.key && mapRoute.key !== 'many') {
        // alert('不是many===key')
        const keyParts: string[] = mapRoute.key.split('.')
        // @ts-ignore
        const value = keyParts.reduce((obj, key) => obj && obj[key], to)
        window.location.href = `${pcUrl}${mapRoute.pcName}${value}`
      }
    } else if (window?.location?.hash?.includes('live')) {
      const fullHash = window?.location?.href
      if (fullHash.includes('isShortUrl')) {
        var idMatch = fullHash.match(/id=(\d+)/)
        var typeMatch = fullHash.match(/type=(\d+)/)
        // 提取id参数的值，如果不存在则为null
        var id = idMatch ? idMatch[1] : null
        // 提取type参数的值，如果不存在则默认为0
        var type = typeMatch ? typeMatch[1] : 0
        window.location.href = `${pcUrl}live/auth?id=${id}&type=${type}`
      } else {
        // 使用URLSearchParams获取id和type参数的值
        const params = new URLSearchParams(fullHash)
        const id = params.get('id')
        const type = params.get('type')
        let params2 = `id=${id}&type=${type || 0}`
        window.location.href = `${pcUrl}live/auth?${params2}`
      }
    } else if (route.name === 'SelfRegistrationDetail') {
      const fullHash = window?.location?.href
      var idMatch = fullHash.match(/id=(\d+)/)
      var id = idMatch ? idMatch[1] : null
      window.location.href = `${pcUrl}signAuto?id=${id}`
    } else if (route.name === 'ExamPractiseInfo') {
      const fullHash = window?.location?.href
      var idMatch = fullHash.match(/practiseId=(\d+)/)
      var practiseId = idMatch ? idMatch[1] : null
      window.location.href = `${pcUrl}practice?practiceId=${practiseId}`
    }
  }, 500)
}

export default jumpPlatform

// 新增：构建PC重定向URL的函数
export const buildPcRedirectUrl = (route: RouteLocationNormalizedGeneric, pcUrl: string, mapRoute: MapRoute) => {
  // 如果没有key，直接返回PC路径
  if (!mapRoute.key) {
    return `${pcUrl}${mapRoute.pcName}`
  }

  // 处理不同类型的key映射
  if (mapRoute.key === 'many') {
    return buildManyKeyUrl(route, pcUrl, mapRoute)
  } else if (mapRoute.key === 'query.redirect') {
    return buildRedirectUrl(route, pcUrl, mapRoute)
  } else if (mapRoute.key === 'live') {
    const id = route.query.id
    const type = route.query.type || 0
    return `${pcUrl}live/auth?id=${id}&type=${type}`
  } else {
    const keyParts: string[] = mapRoute.key.split('.')
    const value = keyParts.reduce<unknown>((obj, key) => {
      if (!obj || typeof obj !== 'object') return undefined
      return (obj as Record<string, unknown>)[key]
    }, route as unknown)
    return `${pcUrl}${mapRoute.pcName}${value}`
  }
}

// 处理 many 类型的路由参数
const buildManyKeyUrl = (route: RouteLocationNormalizedGeneric, pcUrl: string, mapRoute: MapRoute) => {
  switch (route.name) {
    case 'courseDetail':
      const id = route.query.courseId || route.query.id
      const fileType = route.query.courseType !== 'course' && !route.query.courseId ? 1 : 0
      const channel = route.query.channel || 0
      const endingType = route.query.endingType || 0
      return `${pcUrl}${mapRoute.pcName}id=${id}&fileType=${fileType}&channel=${channel}&endingType=${endingType}`

    case 'rollVideo':
      const params = `id=${route.query.id}&boardId=${route.query.boardId}&boardType=2`
      return `${pcUrl}${mapRoute.pcName}?${params}`

    case 'communityDetail':
      return `${pcUrl}${mapRoute.pcName}?id=${route.query.id}`

    case 'ExamInfo':
      return `${pcUrl}${mapRoute.pcName}${route.query.examId}`

    case 'surveyInfo':
      return `${pcUrl}survey/surveyEntrance?surveyId=${route.query.investigationId}`

    case 'surveyDetails':
      if (isTouristChannel(route.query.channel as string)) {
        const params = buildTouristSurveyParams(route.query)
        return `${pcUrl}survey/surveyPage?surveyId=${route.query.investigationId}${params}`
      }
      return `${pcUrl}survey/surveyView?surveyId=${route.query.investigationId}&type=1`

    case 'trainingDetail':
      return `${pcUrl}${mapRoute.pcName}${route.query.id}`

    case 'SelfRegistrationDetail':
      return `${pcUrl}${mapRoute.pcName}${route.query.id}`

    case 'ExamPractiseInfo':
      return `${pcUrl}${mapRoute.pcName}${route.query.practiseId}`

    case 'broadcastDetail':
      const pathMatch = route.path.match(/\/broadcastDetail\/(\d+)/)
      const broadcastId = pathMatch ? pathMatch[1] : null
      return `${pcUrl}${mapRoute.pcName}${broadcastId}`

    case 'applyDetail':
      return `${pcUrl}${mapRoute.pcName}${route.query.id}`

    case 'comDetailLevel':
      return `${pcUrl}${mapRoute.pcName}${route.query.id}`

    case 'broadcast':
      return `${pcUrl}${mapRoute.pcName}`

    case 'lecturerDetail':
      return `${pcUrl}lecturerDetail?lecturerId=${route.query.lecturerId}`

    case 'faceDetail':
      return `${pcUrl}faceDetail?faceId=${route.query.faceId}`

    case 'signDetail':
      return `${pcUrl}${mapRoute.pcName}${route.query.trainConfirmId}`

    case 'community':
      return `${pcUrl}community/communityHome`

    case 'course':
      return `${pcUrl}resource/dailyLesson`

    case 'applyCenter':
      return `${pcUrl}sign`

    case 'task':
      return `${pcUrl}studyTask`

    default:
      return `${pcUrl}${mapRoute.pcName}`
  }
}

// 处理重定向类型的路由
const buildRedirectUrl = (route: RouteLocationNormalizedGeneric, pcUrl: string, mapRoute: MapRoute) => {
  if (!route.query.redirect) {
    return `${pcUrl}${mapRoute.pcName}`
  }

  const decodedURL = decodeURIComponent(route.query.redirect as string)
  const currentHash = window?.location?.hash || ''

  // 根据当前 hash 判断具体的跳转逻辑
  if (currentHash.includes('live')) {
    return `${pcUrl}live/auth?${decodedURL.split('?')[1]}`
  } else if (currentHash.includes('rollVideo')) {
    return `${pcUrl}community/communityDetail?${decodedURL.split('?')[1]}`
  } else if (currentHash.includes('communityDetail')) {
    return `${pcUrl}community/communityPlate?${decodedURL.split('?')[1]}`
  } else if (currentHash.includes('examInfo')) {
    return `${pcUrl}exam/examEntrance?${decodedURL.split('?')[1]}`
  } else if (currentHash.includes('trainingDetail')) {
    const idMatch = decodedURL.match(/id=(\d+)/)
    const id = idMatch ? idMatch[1] : null
    return `${pcUrl}train/trainPage?taskId=${id}`
  } else if (currentHash.includes('SelfRegistrationDetail')) {
    const idMatch = decodedURL.match(/id=(\d+)/)
    const id = idMatch ? idMatch[1] : null
    return `${pcUrl}signAuto?id=${id}`
  } else if (currentHash.includes('lecturerDetail')) {
    const idMatch = decodedURL.match(/lecturerId=(\d+)/)
    const lecturerId = idMatch ? idMatch[1] : null
    return `${pcUrl}lecturerDetail?lecturerId=${lecturerId}`
  } else if (currentHash.includes('faceDetail')) {
    const idMatch = decodedURL.match(/faceId=(\d+)/)
    const faceId = idMatch ? idMatch[1] : null
    return `${pcUrl}faceDetail?faceId=${faceId}`
  } else if (currentHash.includes('ExamPractiseInfo')) {
    const idMatch = decodedURL.match(/practiseId=(\d+)/)
    const practiseId = idMatch ? idMatch[1] : null
    return `${pcUrl}practice?practiceId=${practiseId}`
  } else if (currentHash.includes('broadcastDetail')) {
    const regex = /\/broadcastDetail\/(\d+)/
    const match = decodedURL.match(regex)
    const id = match ? match[1] : null
    return `${pcUrl}trendsDetail?id=${id}`
  } else if (currentHash.includes('broadcast')) {
    return `${pcUrl}fieldTrends?ids=&dataShowRule=1`
  } else if (currentHash.includes('applyDetail')) {
    return `${pcUrl}signDetail?${decodedURL.split('?')[1]}`
  } else if (currentHash.includes('task')) {
    return `${pcUrl}studyTask`
  } else if (currentHash.includes('comDetailLevel')) {
    const idMatch = decodedURL.match(/id=(\d+)/)
    const id = idMatch ? idMatch[1] : null
    return `${pcUrl}community/communityDetail?boardType=1&id=${id}`
  } else if (currentHash.includes('community')) {
    return `${pcUrl}community/communityHome`
  } else if (currentHash.includes('courseDetail')) {
    const courseTypeMatch = decodedURL.match(/courseType=([^&]+)/)
    const idMatch = decodedURL.match(/id=(\d+)/)
    const id = idMatch ? idMatch[1] : null
    const courseType = courseTypeMatch ? courseTypeMatch[1] : null

    if (courseType === 'courseWare') {
      return `${pcUrl}resource/courseDetails?id=${id}&fileType=1&channel=0`
    } else {
      return `${pcUrl}resource/courseDetails?id=${id}&fileType=0&channel=0`
    }
  } else if (currentHash.includes('applyCenter')) {
    return `${pcUrl}sign`
  } else if (currentHash.includes('course')) {
    return `${pcUrl}resource/dailyLesson`
  } else if (currentHash.includes('surveyDetails')) {
    if (isTouristChannel(route.query.channel as string)) {
      const params = buildTouristSurveyParams(route.query)
      return `${pcUrl}survey/surveyPage?surveyId=${route.query.investigationId}${params}`
    }
    return `${pcUrl}survey/surveyView?surveyId=${route.query.investigationId}&type=1`
  } else if (currentHash.includes('surveyInfo')) {
    return `${pcUrl}survey/surveyEntrance?surveyId=${route.query.investigationId}`
  } else if (currentHash.includes('login')) {
    return `${pcUrl}`
  } else {
    if (decodedURL && decodedURL !== '/') {
      return `${pcUrl}${decodedURL.split('?')[1]}`
    } else {
      return `${pcUrl}`
    }
  }
}

// 构建游客调查PC端跳转参数（surveyPage）
// 将H5端调查答题页的游客参数透传到PC端 surveyPage 路由
const buildTouristSurveyParams = (query: RouteLocationNormalizedGeneric['query']) => {
  const keys = ['channel', 'code', 'name', 'bizCode', 'bizName', 'lang'] as const
  const parts: string[] = []
  for (const key of keys) {
    const value = query[key]
    if (value !== undefined && value !== null && `${value}` !== '') {
      parts.push(`${key}=${encodeURIComponent(value as string)}`)
    }
  }
  return parts.length ? `&${parts.join('&')}` : ''
}
